import React, { useState } from "react";
import { Card, Table, Form, Dropdown, Row, Col } from "react-bootstrap";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import EditTrainingTypeModal from "../../../components/modals/hrm/training/trainingtype/EditTrainingTypeModal";
import DeleteTrainingTypeModal from "../../../components/modals/hrm/training/trainingtype/DeleteTrainingTypeModal";
import TrainingTypeHeader from "../../../components/hrm/training/TrainingTypeHeader";
// import EditTrainingTypeModal from "./EditTrainingTypeModal";
// import DeleteTrainingTypeModal from "./DeleteTrainingTypeModal";

const initialData = [
  {
    id: 1,
    type: "Git Training",
    description:
      "Git training covers managing code changes and collaboration using Git commands and workflows",
    status: "Active",
  },
  {
    id: 2,
    type: "HTML Training",
    description:
      "HTML training teaches how to create and structure web pages using HTML tags and elements.",
    status: "Active",
  },
  {
    id: 3,
    type: "React Training",
    description:
      "React training covers building UIs with components, state, and hooks.",
    status: "Active",
  },
  {
    id: 4,
    type: "Nodejs Training",
    description:
      "Node.js training focuses on building server-side applications using JavaScript.",
    status: "Active",
  },
  {
    id: 5,
    type: "Vuejs Training",
    description:
      "Vue.js training focuses on building UIs with Vue.js components.",
    status: "Active",
  },
];

export default function TrainingTypePage() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);

  const filtered = data.filter((item) =>
    item.type.toLowerCase().includes(search.toLowerCase())
  );

  const handleDelete = () => {
    setData(data.filter((d) => d.id !== selected.id));
    setShowDelete(false);
  };

  const handleUpdate = (updated) => {
    setData(data.map((d) => (d.id === updated.id ? updated : d)));
    setShowEdit(false);
  };

  return (

 <div   style={{ padding: "15px", background: "#f8f9fa",  }} >
     <TrainingTypeHeader/>

  <Card className="mt-2" style={{ borderRadius: 5 }}>
      {/* HEADER */}
      <Card.Header
        style={{
          background: "#fff",
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <h5 style={{ fontWeight: 600 }}>Training Type List</h5>

        <Dropdown>
          <Dropdown.Toggle className="border border-1" variant="light">
            Sort By : Last 7 Days
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item>Recently Added</Dropdown.Item>
            <Dropdown.Item>Ascending</Dropdown.Item>
            <Dropdown.Item>Descending</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body>
        {/* FILTER */}
        <Row className="mb-3">
          <Col md={6}>
            Row Per Page{" "}
            <Form.Select style={{ width: 80, display: "inline-block" }}>
              <option>10</option>
            </Form.Select>{" "}
            Entries
          </Col>

          <Col md={6} className="text-md-end mt-2 mt-md-0">
            <Form.Control
              placeholder="Search"
              style={{ maxWidth: 250, display: "inline-block" }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
        </Row>

        {/* TABLE */}
        <div className="table-responsive">
          <Table hover>
            <thead style={{ background: "#f8fafc" }}>
              <tr>
                <th>
                  <Form.Check />
                </th>
                <th>Type</th>
                <th>Description</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((item) => (
                <tr key={item.id}>
                  <td>
                    <Form.Check />
                  </td>

                  <td style={{ fontWeight: 500 }}>{item.type}</td>

                  <td style={{ color: "#6b7280" }}>{item.description}</td>

                  <td>
                    <span
                      style={{
                        background: "#22c55e",
                        color: "#fff",
                        padding: "4px 10px",
                        borderRadius: 6,
                        fontSize: 12,
                      }}
                    >
                      ● {item.status}
                    </span>
                  </td>

                  <td>
                    <div style={{ display: "flex", gap: 10 }}>
                      <FiEdit
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelected(item);
                          setShowEdit(true);
                        }}
                      />
                      <FiTrash2
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          setSelected(item);
                          setShowDelete(true);
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>

        {/* FOOTER */}
        {/* <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <span>
            Showing 1 - {filtered.length} of {data.length}
          </span>

          <span
            style={{
              background: "#f97316",
              color: "#fff",
              borderRadius: "50%",
              padding: "5px 10px",
            }}
          >
            1
          </span>
        </div> */}
      </Card.Body>

      {/* MODALS */}
      <EditTrainingTypeModal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        data={selected}
        onSave={handleUpdate}
      />

      <DeleteTrainingTypeModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onDelete={handleDelete}
      />
    </Card>

 </div>


  
  );
}